import JsonData from '../../data/data.json';

import {CollectionScreen} from './CollectionScreen';
import {HeroSection} from './HeroSection';
import {ThirdSection} from './ThirdSection';

const HomeScreen = () => {
  return(
    <div className={'bg-white'}>
      <HeroSection data={JsonData.HeroSection} />
      <CollectionScreen data={JsonData.collection} />
      <ThirdSection data={JsonData.ThirdSection} />
    </div>
  );
};

export default HomeScreen;
